// tslint:disable: no-inferrable-types

import { Component, Input, OnDestroy, computed, signal } from '@angular/core';
import { Observable, Subject, of, takeUntil, map } from 'rxjs';

import { EasFormControl } from './easform';

@Component({
    selector: 'eas-easform-control',
    templateUrl: './easform-control.component.html',
    styleUrls: ['./easform-control.component.css'],
    standalone: false
})
export class EasFormControlComponent implements OnDestroy {
  @Input() easControl!: EasFormControl;
  @Input() templates = {};

  /**
   * Weather the read-only fields should be visible regardless their values.
   *
   * By default the field is ommited from the form if it does not have value
   * which it does not in the Workflow Editor - From preview.
   */
  @Input() forceDisplayReadOnly: boolean = false;

  $readonlyValue = signal<any>(null);
  $readOnlyVisibility = computed(() => {
    const widgetType = this.easControl.field.widget.type;
    if (['heading', 'paragraph'].includes(widgetType)) {
      return true;
    }
    return !!this.$readonlyValue();
  });

  private unsubscribe: Subject<void> = new Subject();
  public isLoading: boolean = false;

  locked = false;
  lockable = false;

  constructor() {
  }

  showType: 'readOnly' | 'editable' | 'hidden' = 'hidden';
  //FIXME: Do we still need this?
  valueChanged: boolean = false;

  ngAfterViewInit() {

  }

  ngOnInit() {
    this.showType = this.getShowType();
    if (this.showType === 'readOnly') {
      this.getReadonlyValue().subscribe(value => {
        this.$readonlyValue.set(value);
      })
    }
    const options = this.easControl.field.options || {};
    this.lockable = !!options.lockable;
    if (options.lockable && options.locked) {
      if (this.easControl.control.value === null ||
          this.easControl.control.value === this.easControl.field.initial) {
        this.toggleLock();
      }
    }

    //FIXME: Do we still need this?
    if (this.easControl.control) {
      this.easControl.control.valueChanges.pipe(
        takeUntil(this.unsubscribe)
      ).subscribe(value => {
        if (this.easControl.field.initial !== undefined) {
          this.valueChanged = value !== this.easControl.field.initial
        } else {
          this.valueChanged = !! value;
        }
      })
    }
  }

  getReadonlyValue(): Observable<any> {
    if (this.easControl.field.options?.getInitial) {
      return this.easControl.field.options.getInitial(this.easControl.readableValue).pipe(
        map(value => {
          if (value.length > 0) {
            return value[0].name;
          }
          return '';
        }));
    } else {
      return of(this.easControl.readableValue);
    }
  }

  private getShowType() {
    if (this.easControl.field.widget.type === 'hidden') {
      return 'hidden';
    }

    return this.easControl.readOnly ? 'readOnly' : 'editable';
  }

  public toggleLock() {
    if (this.easControl.control.disabled) {
      this.easControl.enable();
      this.locked = false;
    } else {
      if (this.easControl.control.value !== null &&
        this.easControl.control.value !== this.easControl.field.initial) {
        this.easControl.control.reset(this.easControl.field.initial);
      }
      this.easControl.disable();
      this.locked = true;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }
}
